
import React, { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

// Import all pages
import Index from './pages/Index';
import Combo from './pages/Combo';
import Adsl from './pages/Adsl';
import Contacts from './pages/Contacts';
import Solde from './pages/Solde';
import Data from './pages/Data';
import Tempo from './pages/Tempo';
import Outils from './pages/Outils';
import TransferCredit from './pages/TransferCredit';
import NotFound from './pages/NotFound';
import Profile from './pages/Profile';
import AdRequest from './pages/AdRequest';

// Import context and components
import { OnboardingProvider, useOnboardingContext } from './context/OnboardingContext';
import { trackDeviceInfo } from './lib/deviceTracking';
import AppIndicators from './components/AppIndicators';

// Import existing routing components
import RootRedirect from './components/routing/RootRedirect';
import OnboardingGuard from './components/routing/OnboardingGuard';
import ProtectedRoute from './components/routing/ProtectedRoute';

// Create a separate component for the indicators that waits for context
const SafeAppIndicators: React.FC = () => {
  const { isLoading } = useOnboardingContext();
  
  // Only render indicators after onboarding context is fully loaded
  if (isLoading) {
    return null;
  }
  
  return <AppIndicators />;
};

function App() {
  // Track device info when the app loads
  useEffect(() => {
    console.log('App component mounted - tracking device info');
    
    // Only track device info, service worker is already registered in main.tsx
    trackDeviceInfo().catch(console.error);
  }, []);

  console.log('App - Rendering with OnboardingProvider');

  return (
    <BrowserRouter>
      <OnboardingProvider>
        <div className="app">
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route 
              path="/home" 
              element={
                <ProtectedRoute>
                  <Index />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/combo" 
              element={
                <ProtectedRoute>
                  <Combo />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/adsl" 
              element={
                <ProtectedRoute>
                  <Adsl />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/contacts" 
              element={
                <ProtectedRoute>
                  <Contacts />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/solde" 
              element={
                <ProtectedRoute>
                  <Solde />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/data" 
              element={
                <ProtectedRoute>
                  <Data />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/tempo" 
              element={
                <ProtectedRoute>
                  <Tempo />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/outils" 
              element={
                <ProtectedRoute>
                  <Outils />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/transfer-credit" 
              element={
                <ProtectedRoute>
                  <TransferCredit />
                </ProtectedRoute>
              } 
            />
            <Route path="/onboarding" element={<OnboardingGuard />} />
            <Route 
              path="/profile" 
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              } 
            />
            <Route 
              path="/ad-request" 
              element={
                <ProtectedRoute>
                  <AdRequest />
                </ProtectedRoute>
              } 
            />
            <Route path="/404" element={<NotFound />} />
            <Route path="*" element={<Navigate to="/404" replace />} />
          </Routes>
          
          {/* Safe indicators that wait for React context to be ready */}
          <SafeAppIndicators />
        </div>
      </OnboardingProvider>
    </BrowserRouter>
  );
}

export default App;
